<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p><a id="ack">
<div class="fmhT sgc-1">
    ACKNOWLEDGMENTS
  </div>
<div class="fmtx1">
    Thank you to all my friends and family who lent tons of encouragement—along with their stomachs to taste all the food—while I wrote the cookbook. Also, a big thanks to the ever-helpful staff at the NYC Trader Joe’s locations.
  </div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// andr_9781569759516_oeb_ack_r1.vue?533f3c07